export default __webpack_public_path__ + "static/kidney-system-a303fdeeb3b5bb4f591980e5bd74a04c.svg";